import React from 'react';
import Router from './components/Router';



function App() {
  return (
    <>
      <Router />
    </>
  );
}

export default App;